import { Component, Inject } from '@angular/core';
import {
  DIALOG_DATA,
  DIALOG_REF,
  TableRefreshDataAction,
} from '@ansys-internal/awf-angular/shared';
import {
  InputComponent,
  TextareaComponent,
} from '@ansys-internal/awc-angular/forms';
import {
  ButtonComponent,
  ButtonSize,
  ButtonType,
} from '@ansys-internal/awc-angular/buttons';
import { ConceptService } from '../../../shared/services/concept.service';
import { DashboardTables } from '@ansys-internal/awf-angular/dashboard';
import { ActionContributionsService } from '@ansys-internal/awf-angular/contributions';
import { ComponentWidth } from '@ansys-internal/awc-angular/core';
import { DialogRef } from '@angular/cdk/dialog';

@Component({
    selector: 'app-files-rename-dialog',
    imports: [InputComponent, ButtonComponent, TextareaComponent],
    templateUrl: './project-rename-dialog.component.html',
    styleUrl: './project-rename-dialog.component.scss'
})
export class ProjectRenameDialogComponent {
  protected title: string = '';
  protected projectName: string = '';
  protected projectGoal: string = '';
  protected loading: boolean = false;
  protected type: ButtonType = ButtonType.SECONDARY;
  protected size: ButtonSize = ButtonSize.MEDIUM;
  protected awcSizing: ComponentWidth = ComponentWidth.FILL;

  constructor(
    @Inject(DIALOG_DATA) protected data: any,
    @Inject(DIALOG_REF) private dialogRef: DialogRef,
    private conceptService: ConceptService,
    private actionService: ActionContributionsService
  ) {
    this.projectName = data.title;
    this.projectGoal = data.goal;
  }

  async confirm(): Promise<void> {
    this.loading = true;
    await this.conceptService.updateProject(
      this.projectName,
      this.projectGoal,
      this.data.id
    );
    this.actionService.execute(TableRefreshDataAction, DashboardTables.PROJECT);
    this.loading = false;
    this.dialogRef.close();
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
